export default {
  methods: {
    format (num) { //千分位转换
      var reg=/\d{1,3}(?=(\d{3})+$)/g;   
      return (num + '').replace(reg, '$&,');  
    },
    render_distribute(data) {
      // console.log(data);
      data.forEach(v=>{  //销量千分位转换
        if(v.monthVo) {
          // v.saleNumTotal = this.format(v.saleNumTotal)
          v.monthVo.forEach(k=>{
            k.saleNum = this.format(k.saleNum)
          })
        }
      })
      let option = {
          title: {
              text: `年度销量分布`,
              top: 10
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              },
              formatter: params => {
                const arr = data[params[0].dataIndex].monthVo;
                let str = "";
                str = `${data[params[0].dataIndex].year}年<br/>`
                arr.forEach(item=>{
                  str += `${item.month}月${item.newProductCount||0}种销量${item.saleNum||0}<br/>`
                })
                // let all = `总销量${data[params[0].dataIndex].saleNumTotal}<br/>`
                // str += all
                return `<div style="height: 300px; overflow: scroll;"><div class="infinity-scroll">${str}</div></div>`
              },
              position: [10, 10],
              // alwaysShowContent: true,
              // className: 'tooltips-scroll',
              triggerOn: 'click'
          },
          legend: {
              data: ['销量', '产品数'],
              top: 65
          },
          grid: {
            left: 70,
            bottom: 30,
            right: 60,
            top: 120
          },
          xAxis: [
              {
                  type: 'category',
                  data: data.map(v=>v.year),
                  axisPointer: {
                      type: 'shadow'
                  },
                  axisTick: { show: false },
                  axisLabel: {
                    color: 'rgb(135,139,160)',
                    interval: 0,
                    formatter: value =>{
                      if(value.length > 4) {
                        return String(value).substring(0,4)+'...'
                      }else{
                        return value
                      }
                    }
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  }
              }
          ],
          yAxis: [
              {    
                  name: '销量',
                  type: 'value',
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  minInterval: 1,
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  },
                  splitLine: { show: false }
              },
              {
                  name: '产品数',
                  type: 'value',
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  minInterval: 1,
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  },
                  splitLine: { show: false }
              }
          ],
          series: [
              {   
                  name: '销量',
                  type: 'line',
                  yAxisIndex: 0,
                  data: data.map(v=>v.saleNumTotal),
                  itemStyle: {
                    color: 'rgb(250,137,0)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  // showBackground: true,
                  label: {
                    show: true,
                    position: 'right'
                  },
                  select: {
                    label: {
                      show: true
                    },
                    itemStyle: {
                      color: '#ffffff',
                      borderColor: '#00A6ED',
                      borderWidth: 0
                    }
                  },
                  selectedMode: true
              },
              {
                  name: '产品数',
                  type: 'bar',
                  yAxisIndex: 1,
                  data: data.map(v=>v.productNumTotal),
                  itemStyle: {
                    color: 'rgb(11,183,142)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  // showBackground: true,
                  label: {
                    show: true,
                    position: 'top'
                  },
                  select: {
                    label: {
                      show: true
                    },
                    itemStyle: {
                      color: '#00A6ED',
                      borderColor: '#00A6ED'
                    }
                  },
                  selectedMode: true
              }
          ],
          animationDelay: function(idx) {
            return 50*idx
          }
      };
      let $instance = this.$echarts.init(this.$refs['distribute']);
      $instance.setOption(option);
      // $instance.on('click',params => {
      //     console.log(params);
      //     this.$refs['classify'].handleCategoryChange(params.name)
      //     $instance.dispatchAction({
      //       type: 'select',
      //       seriesIndex: params.seriesIndex ? 0 : 1,
      //       dataIndex: params.dataIndex
      //     });
      // });
    }
  }
}